export interface Component {
  destroy: () => void;
  bindEvents: () => void;
}

export abstract class BaseComponent implements Component {
  constructor() {

  }

  public abstract destroy(): void;

  public abstract bindEvents(): void;
}



// WEBPACK FOOTER //
// ../node_modules/tslint-loader??ref--0!../components/base/ts/models/DefaultComponent.ts